import React, { useState } from 'react';
import { Search, X } from 'lucide-react';
import './SearchBar.css';

const SearchBar = ({ onSearch, searchQuery }) => {
  const [localQuery, setLocalQuery] = useState(searchQuery);

  const handleSubmit = (e) => {
    e.preventDefault();
    onSearch(localQuery);
  };

  const handleClear = () => {
    setLocalQuery('');
    onSearch('');
  };

  return (
    <form className="search-bar" onSubmit={handleSubmit}>
      <Search className="search-icon" size={20} />
      <input
        type="text"
        className="search-input"
        placeholder="Search articles..."
        value={localQuery}
        onChange={(e) => setLocalQuery(e.target.value)}
      />
      {localQuery && (
        <button 
          type="button" 
          className="search-clear"
          onClick={handleClear}
        >
          <X size={18} />
        </button>
      )}
    </form>
  );
};

export default SearchBar;